export class ArbreComposant {
    id!: number;
    parent_id!: number;
    label!: string;
    children_id!: string[];
    children_type!: string;
    type!: string;
    codes_pannes!: string[];
    date_heure!: string;
    login!: string;
    type_action!: string;
    validated!: boolean;
}

export class ArbreExplorer {
    path!: ArbreComposant[];
    proofLevel!: string;
    comment!: string;

    constructor(path: ArbreComposant[], proofLevel: string, comment: string) {
        this.path = path;
        this.proofLevel = proofLevel;
        this.comment = comment;
    }

    /**
     * Check if an element id appears in the path, meaning it has been explored
     * @param toFind the element id to find
     * @returns true if id appears in path, false otherwise
     */
    public hasBeenExplored( toFind: string ){
        let found: boolean = false;
        this.path.forEach(element => {
            if( element.id.toString() == toFind ) {
                found = true;
            }
        });
        return found;
    }
}

export class MergeTree {
    node!: ArbreComposant;
    children!: MergeTree[];
    proofLevel!: string;
    comment!: string;
}

export class FormatOptions{

    constructor( color: string, text: string, style: string ) {
        this.color = color;
        this.text = text;
        this.style = style;
    }

    color!: string;
    text!: string;
    style!: string;
}

export class AdditionnalNode{
    node!: MergeTree;
    rightalign!: number;
}